export class Tabs {

    constructor ( target = '.js-tabs', options = {} ) {
        this.target = target;

        this.options = {
            buttonClass: '.js-tabs__button',
            buttonActiveClass: 'js-active',
            sectionClass: '.js-tabs__section',
            sectionActiveClass: 'js-active',
            ...options
        }
    }

    init () {
        this.tabs = Array.from( document.querySelectorAll( this.target ) )

        if ( this.tabs.length > 0 ) {
            this.tabs.forEach( tab => {
                tab.buttons = Array.from( tab.querySelectorAll( this.options.buttonClass ) );
                tab.sections = Array.from( tab.querySelectorAll( this.options.sectionClass ) );

                tab.buttons.forEach( ( button, index ) => {

                    button.addEventListener( 'click', () => {
                        this.switchTab( tab, index )
                    } )
                } )
            } );
        }
    }

    switchTab ( tab, index ) {

        tab.sections.forEach( section => {
            section.classList.remove( this.options.sectionActiveClass )
        } )

        tab.buttons.forEach( button => {
            button.classList.remove( this.options.buttonActiveClass )
        } )

        tab.buttons[ index ].classList.add( this.options.buttonActiveClass );
        tab.sections[ index ].classList.add( this.options.sectionActiveClass )

    }
}
